import {
  getMockRoboadvisorById,
  getMockRoboadvisorList,
  getMockRoboadvisorNotifications,
  getMockRoboadvisorStatus,
} from '#app/mocks/robo';

export interface MockRouteContext {
  entity: string;
  method: string;
  payload?: unknown;
  whereClauses: Array<{ field: string; value: unknown }>;
  orderByClauses: Array<{ field: string; direction?: string }>;
  page?: number;
  perPage?: number;
}

const getWhereValue = (
  whereClauses: MockRouteContext['whereClauses'],
  field: string
): unknown | undefined => {
  return whereClauses.find((item) => item.field === field)?.value;
};

export const resolveMockRoute = (ctx: MockRouteContext): unknown | null => {
  const routeKey = `${ctx.entity}/${ctx.method}`;

  if (routeKey === 'integration/robo-client-status') {
    const payload = (ctx.payload ?? {}) as { id?: number | string };
    const idFromWhere = getWhereValue(ctx.whereClauses, 'id');
    const roboId = payload.id ?? (idFromWhere as number | string | undefined) ?? 111;
    return getMockRoboadvisorStatus(roboId);
  }

  if (routeKey === 'robo-advisor-client/index') {
    const payload = (ctx.payload ?? {}) as { user_id?: number | string };
    const clientId = payload.user_id;
    const roboId = getWhereValue(ctx.whereClauses, 'id');

    if (roboId != null && clientId != null) {
      return getMockRoboadvisorById({
        clientId,
        roboId: roboId as number | string,
      });
    }

    return getMockRoboadvisorList(clientId);
  }

  if (routeKey === 'user-notification/index') {
    return getMockRoboadvisorNotifications({
      pageParam: ctx.page ?? 1,
      perPage: ctx.perPage ?? 5,
    });
  }

  return null;
};
